// auth container forms the frame for the auth screens
export default function AuthContainer({ children }) {
  return <div className="AuthContainer">{children}</div>;
}
